import React from "react";
import Reveal from "./Reveal";
import { House, ConciergeBell } from "lucide-react";
import { FEES } from "../mock";

const ICONS = { house: House, "concierge-bell": ConciergeBell };

const Pricing = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="bg-[#F6F1E8] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16 items-start">
          <Reveal className="lg:col-span-4">
            <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
              Concierge Fees
            </p>
            <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6">
              Transparent, <span className="gold-text italic">always</span>
            </h2>
            <p className="text-base text-[#18324F]/70 leading-relaxed mt-8 max-w-sm">
              Premier concierge services in Marbella, priced simply. No hidden
              costs, only impeccable service.
            </p>
          </Reveal>
          <div className="lg:col-span-8 flex flex-col">
            {FEES.map((f, i) => {
              const Icon = ICONS[f.icon];
              return (
                <Reveal key={f.label} delay={i * 0.1}>
                  <div className="grid sm:grid-cols-[auto_1fr_auto] gap-6 items-center border-t border-[#B88A3B]/20 py-10 group hover:bg-[#B88A3B]/5 transition-colors duration-300 px-4 -mx-4">
                    <div className="w-14 h-14 rounded-full border border-[#B88A3B]/40 flex items-center justify-center">
                      <Icon size={22} strokeWidth={1.3} className="text-[#B88A3B]" />
                    </div>
                    <p className="text-lg text-[#18324F]/85 max-w-md">{f.label}</p>
                    <div className="text-left sm:text-right">
                      <p className="font-serif-lux text-4xl gold-text">{f.price}</p>
                      <p className="uppercase tracking-[0.2em] text-[0.65rem] text-[#18324F]/60 mt-1">
                        {f.unit}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
            <Reveal delay={0.2}>
              <p className="text-sm italic text-[#18324F]/60 mt-8 text-left sm:text-right">
                Please note: Pricing may vary during the summer and low seasons.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
